<template>
    <b-card class="card-accent-danger" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-droplet"></i> <strong>Blood Type</strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <bloodtype-base :callback="createPatientBloodType" />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import { mapGetters, mapState, mapActions } from "vuex"
import BloodTypeBase from './BloodTypeBase'

export default ComponentExtension.extend({
    name: "blood-type",
    components: {
        'bloodtype-base': BloodTypeBase
    },
    methods: {
        ...mapActions('health', ['createPatientBloodType']),
    }
})
</script>